const CHECK_IN_STORAGE_KEY = 'founderDna_checkIns_v1';

const safeParseJson = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

export const getCheckInHistory = () => {
  const raw = localStorage.getItem(CHECK_IN_STORAGE_KEY);
  const parsed = safeParseJson(raw);
  if (!Array.isArray(parsed)) return [];
  return parsed;
};

export const getLatestCheckIn = () => {
  const history = getCheckInHistory();
  return history.length > 0 ? history[0] : null;
};

export const addCheckInEntry = (entry) => {
  const history = getCheckInHistory();
  const next = [
    entry,
    ...history
  ].slice(0, 50); // keep last 50 check ins
  localStorage.setItem(CHECK_IN_STORAGE_KEY, JSON.stringify(next));
  return entry;
};

export const clearCheckInHistory = () => {
  localStorage.removeItem(CHECK_IN_STORAGE_KEY);
};

